module.exports = __webpack_public_path__ + "static/img/champion-hant.b6f3042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/champion-hant.png
// module id = 4zt/
// module chunks = 1